// Notification types that mean "there's something for you to do", and what
// doing it is called. Shared by the header bell (SiteHeader.jsx) and the
// /notifications page. Only unread ones count: once opened, a row can't tell
// whether you acted, so it drops back to the general feed.
export const NEEDS_YOU_ACTION = {
  'new-application': 'Review applicant',
  'new-booking-request': 'Review request',
  'requote-requested': 'Send a quote',
  'proposal-revised': 'Review proposal',
  'submission-pending': 'Grade it',
  'invoice-submitted': 'Review invoice',
  'invoice-unpaid': 'Pay invoice',
  'invoice-disputed': 'Respond',
  'payment-dispute': 'Respond',
  'calendar-proposed': 'Respond',
  'amendment-proposed': 'Review change',
  'order-review-opened': 'Respond',
  'order-review-response-due': 'Respond',
  'order-auto-release-warning': 'Review delivery',
  'order-delivery-overdue': 'Open order',
  'order-expiring': 'Open order',
  'contract-review-opened': 'Respond',
  'contract-review-response-due': 'Respond',
  'contract-auto-release-warning': 'Review work',
  'listing-paused-payouts': 'Set up payouts',
  'onboarding-nudge': 'Finish setup',
  'admin-review-pending': 'Review',

  // These are all real to-dos that weren't listed, so they sat in the general
  // feed: an order request or agreement awaiting a countersign, a quote to
  // sign and pay, and a job offer to answer (the first three used to be sent
  // as 'new-message', which is why they were invisible here); a dispute the
  // other side opened, which has a 72-hour response window; a signed contract
  // the client still has to fund; an invoice chase; a studio application; and
  // team invites and join requests.
  'order-sign-requested': 'Review and sign',
  'quote-received': 'Review quote',
  'contract-offered': 'Review offer',
  'draw-requested': 'Review partial payment',
  'dispute-opened': 'Respond',
  'dispute-response': 'Open dispute',
  'contract-signed': 'Fund escrow',
  'invoice-reminder': 'Pay invoice',
  'studio-application-received': 'Review application',
  'team-invite': 'Respond',
  'team-join-request': 'Review request',
};

export const needsYou = (n) => !n.read && !!NEEDS_YOU_ACTION[n.type];

// Today / Yesterday / Earlier this week / Older, for grouping a feed by day.
export function dayGroup(dateStr) {
  const d = new Date(dateStr);
  const startOfToday = new Date();
  startOfToday.setHours(0, 0, 0, 0);
  const dayMs = 24 * 60 * 60 * 1000;
  if (d >= startOfToday) return 'Today';
  if (d >= new Date(startOfToday.getTime() - dayMs)) return 'Yesterday';
  if (d >= new Date(startOfToday.getTime() - 6 * dayMs)) return 'Earlier this week';
  return 'Older';
}

// 12m / 3h / Tue / Sep 12
export function shortTime(dateStr) {
  const d = new Date(dateStr);
  const m = Math.floor((Date.now() - d.getTime()) / 60000);
  if (m < 1) return 'now';
  if (m < 60) return `${m}m`;
  const h = Math.floor(m / 60);
  if (h < 24) return `${h}h`;
  if (h < 24 * 6) return d.toLocaleDateString(undefined, { weekday: 'short' });
  return d.toLocaleDateString(undefined, { month: 'short', day: 'numeric' });
}

// Consecutive runs of the same day label, in feed order.
export function groupByDay(items) {
  const groups = [];
  items.forEach((n) => {
    const label = dayGroup(n.createdAt);
    const last = groups[groups.length - 1];
    if (last && last.label === label) last.items.push(n);
    else groups.push({ label, items: [n] });
  });
  return groups;
}
